module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-5",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ARRIVALS")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("November 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Don’t freeze, don’t freeze—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Awareness running through his body, concentrating for split seconds in the soles of his feet, his hands, the centre of his back where the rifle or machine pistol would be aimed, the back of his head. The moment of silence after the soldier had given his order, and McBride listened for the first step back, the adjustment the German would make to let him drop at a safe distance. No scuffle of boots—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Drop!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("His hands seemed to come unstuck from the icy guttering very, very slowly, and his body drop through the air much too unaffected by gravity—he was floating, it wouldn’t work")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and his body could see the gun, the white upturned face backing away—then his boots hit the soldier a glancing blow, his fall was broken, he struck the concrete heavily, winded, rolled over, tried to get up and knew he was moving as awkwardly as if his legs were under water, then saw the German down on one knee, trying even more slowly to bring the machine pistol to bear. He’d been caught by McBride’s lack of delay, but he was recovering. McBride’s arm and shoulder hurt from impact with the ground as he thrust up into a crouch, and hurled himself against the German, felt the rough serge of the field-grey against his cheek, the cold metal of collar-tabs, the edge of the helmet against his head—heaved rather than cannoned against the soldier, knocking him backwards. He heard the explosion of breath, the sharp clatter of the machine pistol, as he rolled over the German, raised his upper torso and looked down into the young, scared face, its mouth opening much too slowly to yell. McBride pulled at the helmet strap and jerked the head back. The mouth contorted, remained silent except for a gurgle, then McBride struck the German with his fist, below the ear. The head lolled when he let it free.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Immediately, he climbed to his feet, aware of the shadows alongside the shed, sensing the rain-blown night, aware of the silence beyond the muffled noises from inside. Then he dragged the unconscious—possibly dead—soldier up against the corrugated wall and left him, moving away immediately towards the pier-end of the shed. When he reached it, he paused. There was another hour and a half before the shifts changed, and he could not wait. The German would be unaccounted for inside five minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He was surprised at the manner in which his mind sought the amusing, the unexpected, solution, even as he looked at his watch and some more urgent part of the organism collected swiftly the few sensory impressions along the pier. A radio, muffled hammering, the spit of welding equipment, the patter of the sleet against the wall of the shed. He turned round with deliberate calm and walked back to the unconscious German.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He bent over him. There was breathing, tired and quiet. He lifted the head like an easily bruised fruit and removed the helmet. Then he tugged the German out of his greatcoat, the back of which was sodden, and removed his boots. He removed his own donkey jacket and boots, became in seconds a German soldier. He buttoned the greatcoat right to the throat, picked up the machine pistol, and returned to the pier. He paused only for a moment, as if patting mental pockets for required and necessary equipment, then began walking with a tired, bored shuffle towards the warehouse and the barrier.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And with each step the nerves increased, as he knew they would however much he attempted to disguise them in confidence, in indifference. He was aware of his heart rate increasing, of his body temperature rising; employed deep breathing to calm himself, gripped more tightly the stubby barrel of the machine pistol. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He was past the warehouse, and the barrier at the end of the pier was the only thing in his vision, when someone spoke in German, and he knew the voice was addressing him. The man he appeared to be. But he caught the note of uncertainty, too, just as clearly as he heard the footsteps coming from the side of the warehouse, closing on him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Friedrich, where the devil have you been? Friedrich?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The puzzled tone hung on the air like frost. McBride was a hundred yards or so from the barrier, and a man he could not turn to see was coming from behind him. Each footstep separated in time, almost to the rhythm of the dance music he could hear from a radio. He half-turned, and slipped, sliding on to his back, his greatcoat billowing like a skirt. The soldier behind him burst into laughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Friedrich, you’re pissed, you bastard! Where is it, where’s the drink, you selfish little—?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride rolled on to his side, propped on one elbow, the machine pistol pointing up into the German’s face.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘If I kill you, I’ll attract their attention, I know that. It just won’t do you much good, old friend,’ he observed in German. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Drink, drink")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was coming to him. The German’s mouth kept slowly popping open and closed, then he began sucking his cheeks to wet his dry throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What’s your name?’ Puzzlement almost approaching the catatonic. ‘Just tell me your name—it might save your life.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Willi—Willi Frick.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well done, Willi.’ McBride stood up, leaned against the German with a smile, and pressed against the nerve below his ear, just behind the chinstrap. Willi slid against him, gently declining. McBride pulled the rum flask from his pocket, and spilled liquor into Willi’s mouth, down his chin and on to his coat. He let Willi lean unconsciously against him as he checked his own papers again—Friedrich Bruckner, and his rank, unit and number.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Come on, Willi,")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you’re going on a charge, and me with you.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He slipped Willi’s right arm round his neck, hefted him upright, his own arm round Willi’s waist, and walked him towards the barrier, making an exaggeratedly slow approach in the shadow of the warehouse, stepping out into the light only at the last minute—but by that time a Kreigsmarine Leutnant was already calling him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Soldier, what the devil are you doing? You, there!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride snapped to attention, and Willi began to slide to the ground. McBride grabbed him, straightened the body. Someone laughed behind the officer, who seemed suddenly to consider it all as simply another scheme to make him appear foolish. His face contracted as if he had sucked a lemon and he marched across to McBride, who tried to adopt peasant stupidity as his habitual expression.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What’s going on—’ Nose wrinkling, suspicion gleaming in his eye. ‘This man’s ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("drunk!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sir—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No excuses—breathe on me, you dummy!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride exhaled. The Leutnant shook his head in obvious disappointment. The guards behind him had formed a knot of eager spectators—one or two of them trying to make McBride smile or laugh by mimed antics. and expressions. They were fifteen yards away—too far to hear his replies, his claims to identity. He kept a rigid face as the officer continued.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Where did you find him?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Heard someone singing behind one of the warehouses, sir!’ he snapped out.\t")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Him?’ The Leutnant was disgusted. McBride nodded. ‘And now he’s passed out you weren’t going to report this, were you?’ Again, the gleam of realisation and superior understanding. McBride looked guilty. ‘Trying to sneak him back to his billet, weren’t you?’ McBride swallowed, nodded. ‘What’s your name?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride barked out his assumed identity. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Him?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Frick, sir.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Leutnant made a note (with a gold-encased pencil) in a little notebook contained in what might have been a slim cigarette-case. He put them away with a quiet triumph.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Both of you—report to me in the morning. Now, get that disgusting clown out of my ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("sight!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sir.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride grabbed Willi’s body more securely, kept his head down as he half-pulled him past the barrier, to the raucous laughter—soon quietened by the Leutnant—of the rest of the guards. He could hear them discussing the likely charges with the Kreigsmarine officer as he moved beyond the cold splash of the light above the barrier and the guard hut. He heaved and pulled at the unconsciously-resisting Willi,")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a chill bath of perspiration covering his body from the effort and the bluff. He couldn’t control his body’s relief, and it irritated him. Eventually, he was in the shadows of a seaman’s church opposite the Albert Pier, and he thankfully dropped Willi into the shadows by the wrought-iron gate. He looked up. A chill, unwelcoming little church, the rain like a shiny skin on something gone cold. He shivered, and moved swiftly away, the machine pistol over his shoulder, the sweat drying on his forehead at the line of the helmet and under his arms. He wasn’t quite ready to smile. He hurried up the Quay to the North Esplanade, out of the centre of the town.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("October 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride wondered whether it was courtesy on the part of the attaché who met him at Tempelhof, or the habit of security, that the man acquired his papers and ushered him through Customs and passport control in the terminal building. McBride had flown in on a Trident to Tempelhof, West Berlin’s principal airport. He wondered briefly why the Cultural Exchange Committee of the Democratic Republic had bothered to send an escort to the airport, and was more surprised at the deference with which he was treated, and the obvious and studied compliments on his book, Gates of Hell produced like mottoes from Christmas crackers by Herr Lobke. The young man seemed anxious to please, yet almost too aware to be the pleasant, rather naive, person he exuded in McBride’s direction.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("‘Professor Doktor Goessler is, I know, very anxious to meet you, to offer his help; it is a remarkable compliment.’ McBride almost sensed the unspoken addition of ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("to someone like you, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but opted to accept the enthusiasm, the desire to be merely helpful.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Outside the terminal building, a black Lada saloon drew alongside them almost in the instant that Lobke raised his arm. There was even a uniformed chauffeur. One or two arriving passengers glanced at the little tableau, then disregarded it as if dissatisfied with the size or make of the car. McBride slid across the bench seat at the back, and Lobke climbed in beside him. The chauffeur pulled the sun visor down and accelerated away from the terminal doors.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They picked up the Tempelhofer Damm, pointing north like an arrow at the city. Lobke seemed impressed and distracted from him by the passage of the numerous Mercedes saloons, the Porsches and Datsun sports cars. McBride indulged the immediate excitement of the urban autobahn, the tall buildings, the neon silent but endlessly boastful. The advertisement of the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("wirtschaftwunder, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a slick, affluent stranger in")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a peasant economy. West Berlin, he sensed immediately, postured like a glamorous, be­ jewelled model against the temporary ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("chic ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of a ghetto or a slum. The city shouted at him, demanded he accept its image as reality.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They crossed the Spree on a high arch of pale concrete, to the Friedrichstrasse. McBride had been to Berlin before, researching ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Gates of Hell, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but then the city had evidenced to his tunnel vision the remnants of its battering in 1945, its German-ness, its foundation of ash rather than its post-war substance. Now, he had no preconceptions—he was there to study documents, follow an old, cold trail, and the city leapt upon his senses.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There was a short delay at Checkpoint Charlie, on the American side. The guards seemed uninterested, in the late afternoon sunshine, in McBride as an American, but they checked Lobke’s papers thoroughly, even though he had obviously crossed from East to West earlier in the day. On the East German side, the barrier was up almost immediately, and there was a smart salute for the car from the guards. The grey breeze-blocking of the Wall was almost obscured from the consciousness by the ceremony, the swiftness, of their arrival in East Berlin. Except that the Wall was suddenly high enough to cast a long shadow, out of which only after a few seconds did the car emerge into the slanting sunshine of the Friedrichstrasse again.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("One of the Vopos on the checkpoint telephoned the arrival of McBride and Lobke less than a minute after their crossing.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride, ringing from Koblenz, had booked a room at the Hotel Spree, an ugly block of pale concrete on the Rathaustrasse near the river and the Marx-Engels Platz. The porter seemed entirely respectful, the desk staff willing and welcoming. The hotel foyer was modern—polished dark wood, greenery and thick carpet, a coffee shop open-planned to one side. He could have been in")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("any modern four-star hotel in the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lobke left him in the foyer, shaking his hand with a")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("formal warmth, and promising that Professor Doktor Goessler would be certain to contact him. Lobke watched him get into the lift behind the porter carrying his bag, waiting until the door sighed shut, then placed his ID on the desk in front of the clerk.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Where’s the secure phone?’ he said. The clerk seemed unsurprised, nodding to a row of four plastic globes sprouting from the wall alongside the coffee-shop. ‘Second from the left,’ he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lobke crossed the foyer, watched by a woman in a beige coat and boots who was sitting in the foyer in order to be noticed. Lobke thought he recognised her from the television-news programmes. Lobke didn’t like the Hotel Spree and its spurious Westernism. He disliked it because it was part of a façade—behind it the grimy dullness of the DDR waited to displace fantasy. To jump out and remind the dreamer that it was a joke, nothing more substantial. On the contrary, he liked West Berlin, liked any messenger-jobs to the Federal Republic, or the rest of Europe. The shiny toys were real there. ‘")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Meanwhile the stupid cow in her Italian boots and West German coat waited for her dreary friends from East German TV or the pretend-glossy magazines. He dialled headquarters. Asked for Goessler after identifying himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Chief?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Rudi, how did it go?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘He’s booked in. Seems to be enjoying himself—I think he’ll go all the way with you, Chief.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Rudi, what TV stations are you watching these days?’ Lobke laughed. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Ours, naturally.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘OK—well done. I think I shall call Herr Professor McBride at once and introduce myself.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Goodbye, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Professor.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lobke put down the telephone, winked coarsely at the woman in the beige coat who turned her head away immediately, and then he went out of the revolving doors into the evening sunshine, to walk along the Rathaustrasse to Marx-Engels and the Unter den Linden. He liked to look at the Brandenburger Tor with the low sun coming through its columns. It seemed to hold out a vague promise, made to him personally.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride unpacked methodically as soon as the porter left, with the tip in dollars that he was not, by law, allowed to receive at all. He always staked his claim to possession of any temporary home by spreading his things around—the toiletries on the bathroom shelf especially helped to establish his claim. While he was still putting socks and pants into a drawer, the telephone rang.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘McBride.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Ah, a call from Professor Goessler of the University for you, Herr McBride.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Put him through, please.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride straightened at the telephone, as if before a superior. The window of his room looked over the shop roofs on the Rathaustrasse, towards the cathedral. He was pleased it did not face in the opposite direction, where he would have seen, beyond St Hedwig’s, the Wall.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Professor McBride?’ The voice of a jolly man—an image he would not have connected with an East German Marxist historian. He shook his head at his own misconceptions.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Professor Goessler, good of you to call me, sir.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The pleasure is mine. Please, you are comfortable at the Hotel Spree—it is suitable?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sure, fine, Professor.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Good, good—if you had given us time, I would have booked your room for you. However, you have not made a mistake with the Spree. Tell me, my friend, are we to get right down to business, as you would say?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m in your hands, Professor. I haven’t changed my ideas since I wrote you.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And you expect to find what you are looking for here in Berlin, in our archives?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What do you think my chances are, Professor? You’ve been through all that stuff the Russians gave back in the sixties and seventies.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘My friend, I have only scratched the surface, I assure you!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride felt a thin, needle-like sense of satisfaction that Goessler seemed ignorant—and a disappointment at the work in front of him. Needles in haystacks.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I see—but you’ll give me freedom of access?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("‘Naturlich")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("—oh,")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’m sorry. No, but you speak German, of course. My friend, perhaps we can have dinner together this evening?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride looked at his watch. Six, almost. ‘Sure. Here any good, Professor?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘A rather bland cuisine, but it will not hurt us. Yes, shall we say eight?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sure. Ring my room when you arrive, Professor, and I’ll meet you in the bar.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Excellent. Goodbye.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride put down the telephone, and crossed thoughtfully to the window, recognising the process of revising prejudices going on inside him. How could he complain at the treatment? He stared at the cathedral, blackening in the shadows and the low streaming sun.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He suddenly received a curious image of himself crawling over the face of that cathedral, checking each of the figures and gargoyles carved on it, looking for a piece of paper with its secret message stuffed up one stone nostril of one of the hundreds of stone saints and devils. He laughed. If ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Smaragdenhalskette ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("had dropped a couple of its stones in East Berlin, then he would find them.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("November 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride hunched down between two rocks, jammed in as if afraid he might lose some precarious hold. The greatcoat, which he had wanted to abandon half a dozen times, now kept out the searching wind that moaned off the sea and moaned against the low cliffs of the cove. The tide had just turned, and the sea, because the wind was from the north and against the tide, was choppier than when he had rowed in. It would be harder for him to pick out the submarine when it surfaced bow-on to the cove. The deflated carlin float was hidden only yards from him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He’d returned the way he had come, avoiding the guard posts since, despite his uniform, he had no movement order or excused-duty chit. It had taken him almost three hours. He looked at his watch again, then took up the signal lamp. If the submarine was out there, he wouldn’t know it until it surfaced. He was early, and all he could do was to signal periodically and hope they were using the periscope.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He flashed the morse signal, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("M, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("put down the lamp, and listened. He’d heard a couple of cars and a truck pass along the road above him, but nothing had stopped. Yet he knew that by now they must be searching for him—someone would have found either Willi or Friedrich or both of them long before, and they would have been able to describe him and what he’d been doing when Friedrich surprised him. And they’d want to finish him off, deducing that he’d be taken off by submarine before light. And from one of the narrow, sheltered coves at the northern tip of the island, near l’Ancresse Bay.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He listened. Impatient, he picked up the signal lamp again, hesitated more out of pride than caution, then flashed his morse ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("dash-dash ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("identification out to sea. The rain had stopped, but the wind was colder now, angering the sea as if to provide another barrier to his escape. He hugged the lamp to his chest while despising its use as a comforter.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then, almost involuntarily, he flashed out the ident once more, gripped by a panic he could not laugh at or depress. He put back his head, and breathed as deeply as he could, inhaling and exhaling regularly for a minute or more. When he looked at the choppy, threatening, empty sea again, he could hear the sound of engines; identified them almost at once, and waited until the German S-boat rounded the low headland, its searchlight sweeping the tossed surface of the water, then—more in hope than expectation—flickering and dancing along the cliff face, off the huddled groups of rocks. The tide on which he had come in had removed all traces of his arrival.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The S-boat—he watched it in helpless fascination—moved inshore and he could just make out the toy-like figures in caps and duffle coats behind the coaming, the sailors at the bow operating the searchlight, or waiting armed with rifles and machine guns.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He thought he detected the sounds of vehicles from the clifftop even as the searchlight bounced away above his head, but the noise of the S-boat’s twin diesels boomed off the cliffs, magnified and drowning any other noise. He felt his body temperature drop, the wet rocks press on him. Then the searchlight moved on, sweeping back out to sea. The S-boat moved away, and in less than another minute had rounded the opposite headland, and its engine-noise dropped away.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then he heard the shouted orders from above him. He ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("had ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("heard a truck stopping. He fumbled with the signal lamp, adding to its shielding with his cupped hand as he flashed his signal on and off, again and again. The S-boat would be back, or another might be following, and in minutes, when the troops sent to search the cove had descended the cliff path, he would be unable to signal.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Come on, come on—for Christ’s sake, come on,’ he muttered over and over like an incantation, flashing the ident out to the rough, empty sea, listening to the banging of the truck’s tailboard, the scuffling of boots and the clink of metal which some freak of the wind brought to him clearly. He might even hear them click on their torches.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Come on, come on, come on—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("October 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride wondered whether the crêpes suzettes after the richly sauced venison was for his benefit, or whether Professor Goessler was indulging himself in the surroundings of the Hotel Spree’s dining room and its cuisine. McBride felt full, and impatient. Goessler—florid, large, beaming, grey hair swept back into wings at the peripheries of a bald pink dome, bulbous nose and full lips—was someone who spoke little while he ate, except for pleasantries concerning the meal. Who would settle the bill had not been decided, but McBride, with some quiet amusement, considered it was more likely to be American Express than the University Bursary.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When Goessler had finished his ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("crêpes, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("he sat back, dabbed his mouth with his napkin in a tidy little gesture that would have suited a smaller head and more delicate hand, and beamed once more on the American.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Not for your goodwill, you understand,’ Goessler said with unexpected perception. ‘This is what they serve here every night, not just when Americans are resident.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride laughed, put down his fork. The ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("crêpes ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("were beginning to pall on him, possessing a certain unmistakeable Germanic heaviness, richness.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Coffee?’ Goessler nodded, and McBride summoned the waiter. ‘Schnapps?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Bring me an Asbach brandy,’ Goessler told the waiter without replying to McBride, as if he had been irritated. There was also a barely masked ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("casualness ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of authority, as if it had been long-accustomed, about the way he addressed the waiter. ‘And you, my friend?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’ll pass—just coffee.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Bring a pot, and leave it,’ Goessler instructed, and the waiter nodded. ‘Large cups,’ Goessler called after him. He beamed on McBride, as if reassuming a role. ‘Now, of course, you wish to talk. Go ahead.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Permission to speak? ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride was puzzled by Goessler and resolved the German academic must be interested in his work. Perhaps too interested—then again Goessler, interrupting him as he was about to speak, said: ‘Do not worry, my friend, I am not concerned to steal your work—’ Again the broad smile, and the mouth almost overfilled with dentures. ‘No, I can imagine what you must think of me. Softening you up, mm?’ He indicated the plates before them, looked with passing regret at the remains of McBride’s ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("crepes. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, I am at present at work on more ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("dialectical ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("material—the official history of the German Communist Party, from the beginnings. I don’t think any work of yours is likely to throw up new material for me, eh?’ He put back his head, laughed, then smoothed the wings of grey hair flat against his head. ‘No, no, not that I would not perhaps change places with you—’ He leaned forward confidentially. ‘To be truthful, much of ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("my ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("research is extremely dull. I do not suppose yours is, mm? What is it—what invasion plans are you wishing to discover?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Illuminate, you mean? Each one of the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fallen, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("every invasion up to and including ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Barbarossa.’ ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride returned the unblinking stare, the slightly fixed smile. Then Goessler nodded, as if releasing him from hypnotic control.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Very well, but I warn you, the bones have been well picked over by the Soviet Historical Academy.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But for their purposes, not mine.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Ah, true—they weren’t writing for the American mass-market.’ Goessler laughed disarmingly, and McBride felt it impossible to be nettled by the implied slight. ‘Anything in particular, my friend?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride had weighed the moment in advance, while showering. He could get nowhere without Goessler—Goessler might know ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("people, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as well as documents. He had decided to tell him. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘A little-known invasion plan without a ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fall ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("designation—called ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Smaragdenhalskette?’ ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He turned the remark to a question on the last word. Goessler crinkled his shiny forehead, then shook his head. The grey wings of hair loosened their grip on the sides of his head. He brushed them back again.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The name means nothing to me—but, we can put some of my postgraduate students to work with you, Professor, to save you time.’ He clapped his hands together, possibly at the arrival of the coffee and brandy. ‘Yes—we shall do that for you, certainly. Your own little research team—and we will see what turns up, mm?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("David Guthrie sat in one of the beige PVC chairs with a tubular steel frame common to many current affairs programmes. Opposite him sat a renowned but belligerent interviewer, a low glass table between them. Guthrie always insisted on this staged informality when he was interviewed on television, rather than become a talking head and trunk behind a desk. He was never pedagogic in his manner, eschewing all suggestion of lecturing or hectoring that a formal setting might convey.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Red light—a camera moving in on him, “the interviewer aware of the director shouting in his earphone and the link man’s voice across the studio. Guthrie felt the slightest pluck of tension, adrenalin sidled through him. He smiled in the general direction of the interviewer, half-profile to the oncoming camera. Behind the cameras, beyond the meagre area of carpet, the bareness of the studio suddenly impressed itself upon him—he kept the smile, but deepened it as if prior to serious thought. His little circle of bright light, himself spotlit, and the rest of it nothing more than a façade. Was he pretending that the Leeds Castle conference was a substance, a reality? He made almost as if to protest at this pushing, uncomfortable prevision.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Secretary of State, we’ve heard on the news tonight of a further spate of fire bombs in Belfast, of two bombs being defused in Birmingham, and an explosion in Glasgow. What do you say to those people who tonight are worrying for their safety?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Guthrie did not clear his throat, but leaned slightly forward, talking to the interviewer but at points of emphasis turning to the camera.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I wish there was better news—I can only tell you that the Government, in cooperation with the police, the Special Branch and the security forces in Ulster, is committed to hunting down and removing into custody the people guilty of these hideous crimes.’ His eyes glittered, and the interviewer, who knew Guthrie as well as anyone in television, suffered the familiar moment of doubt as Guthrie seemed to shift into a higher gear of response, of emotion. He could not decide—ever—whether it was a political or a human response. ‘I ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("saw ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the film of those people being carried out of the wreckage of that supermarket in Belfast—just as your viewers did. We want this business ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("finished.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But, Mr Guthrie, many people may well consider you to be one of those guilty men. Is it not your conference on Northern Ireland that has directly led to these latest attacks here and in Ulster?’ The interviewer disturbed his papers, as if checking his own question.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I would understand that, except that I’m sure that the people of this country—of the United Kingdom—understand by now that the conference which is scheduled to begin next week ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("is ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the answer to the bombings, the killings and the violence. It is not the cause.’ He smiled at the camera soberly, with ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("gravitas. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘All the parties except the IRA ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("want ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the conference to succeed. They are frightened—showing their fear openly. What we must not do is to lose resolution. We can win—we will win—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Mr Guthrie, you say that we can win. Have the Provisional wing of Sinn Féin or the Reverend Ian Paisley agreed to attend the conference?’ Bullying the answer out of him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘As to Sinn Féin—official Sinn Féin will attend. I have the strongest private assurances, also, that no prominent body of opinion on the Protestant side will be absent.’ Smile, suggesting discretion rather than evasion. ‘The bombers, as we might expect, will not be there. They do not represent ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("anybody—")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("this conference will be attended by every party which seeks a peaceful solution. And every ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("representative ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("party in the province wants peace.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Now, if we can move on to the area, Minister, of the agenda of the conference—’ Guthrie nodded, sitting back in his chair. ‘Are we to understand that attendance at the conference by all responsible parties implies an agreement with your power-sharing proposals in Northern Ireland?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Guthrie paused, weighing the question. ‘I won’t prejudice—or pre-judge—the outcome of the conference by outlining demands or even suggestions. The kind of political power-sharing, the kind of government in Ulster is what the conference has to decide.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Just one moment, Minister—’ The interviewer touched his earphone, listened, and his face became grave, pressing into its most belligerent lines. He nodded, then said bluntly: ‘We’ve just received news of an explosion in a restaurant off the Charing Cross road—there may be as many as thirty dead and wounded.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Guthrie looked appalled, as if some direct and violent attack had been made upon him. The studio appeared no longer bare; more it was insulated, safe.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘We’ll go to the newsroom for more details—’ the interviewer added, almost unnecessarily. Guthrie appeared unable to speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Not one arrest—not a single arrest. People would be frightened, would contemplate drawing back. He knew he was poised upon a critical moment, yet he was unable to speak, to reassure, to offer solutions. His conference, his career, lay with the bodies and the broken glass and the walls stained and scorched. The Provos had brought their war to him, and they could yet win. The red light winked off on his camera, and he rubbed his face as if trying to remould flesh grown suddenly loose, shapeless.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("November 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He had perhaps two minutes in which to get the carlin float down to the waves, inflate it, and begin rowing out to sea—to nothing and no rendezvous. The sub must have moved offshore, dived deeper, when they picked up the S-boat on asdic. Another truck moved along the clifftop, stopped, and he could hear the soldiers being disgorged. What he had seen he was not to be allowed to report.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("What had he seen, then?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Get on, get on—There was no time to debate the significance of the sheds and what they concealed. He was simply a camera, film waiting to be developed by an expert. He could not hope to mingle with the searching patrols when they reached the beach, no chance that they would not find the deflated carlin float hidden in the rocks. Yet as soon as he moved, even on that dark beach, he would be spotted. Time was to be measured in strokes of a paddle, and the range of a German rifle.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He flicked the ident twice, then sent the emergency distress code. His head wavered between the clifftop—crunch of boots on the loose gravel of the cliff path—and the empty sea. Then he moved, crouching his way to the float, hoisted it on his shoulder, and began running, labouredly and reluctantly, down the beach towards the water. Even the wind resisted his efforts, it seemed, and his feet began to sink into the newly uncovered sand, slowing him. All the time, he listened behind him and looked ahead, waiting.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They must have seen him, must have …")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He splashed through the shallows, flung down the float, knelt by it in the bubbling white foam, and released the stop on the compressed-air canister. The air roared, and the yellow float bucked out of his grip, writhing as it inflated automatically, growing like a nearing target.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Shouts?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He looked out to sea—black shape against the darkest grey? No.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He experienced a moment of paralysis close to panic, until the first hopeful shots from the cliff path could be heard above the noise of the waves and the wind, and he was startled into looking back. He could see torchlight wobbling and hurrying down the side of the cliff, see the headlights of the trucks as they backed and turned seaward to illuminate him. Torches flashed uselessly out to sea. He stumbled through the surf, cursing himself and tugging off the restraining, soaked German greatcoat. The wind cut through him as he let it go and clambered into the float which seemed to want to rush back towards the shore, then tumble away from him out into the cove. He unhooked the paddle, began pushing at the water, desperately overcoming the onrush of the water, waiting in a space full of shouting and gunfire, then feeling the retreating tide grip his float more severely, lifting him out to sea. He paddled furiously as soon as its grip lessened, fighting the next incoming wave—water splashed into his face, froze his hands almost at once, drenched his body through the three sweaters. He yelled, struck, yelled, struck—driving the bobbing, wild float into deeper water.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Bullets plucked at the water to left and right—one cried closer than the wind, and he instinctively ducked. Nothing, nothing out to sea. The signal lamp had gone, with the greatcoat or with the water slopping in and out of the float. The wind palpably restrained him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Radio—there must be a radio in one of the trucks in touch with the S-boat, to bring it back to pick him up.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He looked back, fleetingly, as if ducking from the blow of the next wave and the slosh of stinging, icy water the wind whipped off its crest—saw the figures on the shoreline, in the stance of riflemen.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It would take one bullet. He ducked into his next stroke, renewing the frenzy of his activity, his vision confined to the bottom of the float, which was gradually filling, and to the next wave. Hearing above the wind the buzz of bullets, the shouted orders now far behind him, and with no sense of the futility of his escape.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He looked up.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Black shape, bow-on. A submarine surfacing and blowing its tanks, the conning tower running with water, decks awash—perhaps five hundred yards from him. Increased firing, but he was suddenly invulnerable. He struck madly with the flat paddle, heaving the float through the waves, his arms and shoulders protesting and his hands dead and fixed vice-like by the cold to the paddle.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He was up to his waist in water suddenly, having heard nothing of the bullet’s passage through the float, with no sense of impact or deflation. But the carlin float ducked almost shamefully beneath the next big wave, and the paddle remained too deep in the water to make its next stroke. He unclenched his hands and was at once at the mercy of the waves, flung under then up as he struggled, then under again. The sweaters and his stolen jackboots seemed impossibly heavy—he struggled out of the boots, swallowing water, coughing, let the boots drop away through the water, tried to pull off one of the sweaters, but could not tread water to do so.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He looked ahead—the submarine was still five hundred yards away, but he could see the dinghy they’d launched, and began to swim very slowly, furiously, towards it.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He was in the water for a long time, aware of the recurring drag of the tide taking him out, but seeming always weaker than the water that heaved over his head with each incoming wave. He drove forward with heavy arms, legs kicking feebly, the weight of his clothes increasing—deadweight, dragging him downwards. He was not certain, but there seemed to be short black intervals between successive strokes, between the times he lifted his head to try to spot the dinghy. His view was a succession of flashing images, as through a lens-shutter, alternating, the black moments elongating, swallowing reason.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They dragged him in, unceremoniously, head first so that his face was plunged into the slopping water in the bottom of the dinghy. Two men in oilskins immediately began to pull back towards the submarine, and a third pulled him into a sitting position. He was grinned at in the darkness.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘All right, sir?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He nodded, retched but brought none of the swallowed water up, then nodded again with more affirmation.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That S-boat—’ he began hoarsely.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Skipper’s watching out for it, sir, don’t worry!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride simply nodded, and retreated a little into his sense of relief until the dinghy banged against the hull of the submarine, hands took hold of its ropes and the Petty Officer in the dinghy handled him like a child being lifted up to see some passing sight above a crowd of heads. Other men in oilskins—the smell of them was omnipresent—assisted him along the swaying, unsteady, awash after­deck towards the conning tower.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Ditch that dinghy! Our friend’s back,’ he heard from close to him. Two young faces under caps, one of which nodded to him, and round the headland he had a momentary glimpse of the reappearance of the S-boat, searchlight trained ahead of the craft to pick them up.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Shake it up down there!’ someone barked. McBride was bundled down the conning-tower ladder, stumbling and weak. ‘Clear the bridge!’ he heard the same voice call above him. Seaboots thumped over his head, and then his rescuers dropped one by one into the confined space. He was aware of faces watching him intently, then the captain closed the hatch, and dropped at his side. The klaxon sounded. ‘Dive, dive, dive!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("After someone had thrown a blanket over his shoulders, no one took any more notice of him. His rescuers disappeared, and each man but himself seemed to have a task that precluded all other activity or sensation.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘HE at Green Nine-Oh, increasing, sir,’ the asdic operator called.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Starboard thirty, steer Three-Two-O—full ahead together.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Three-Two-O, full ahead together, sir,’ the coxswain answered. Then there was a sudden strained silence, punctuated only by the pinging of the asdic as the S-boat closed on their position. McBride was suddenly entirely apart from the men in the control room—the cause of their danger. McBride glanced from face to face—the captain alert beside him near the periscope column, the first officer at the diving panel, the two men at the hydroplane controls, and the coxswain the wheel")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride heard the throb of the S-boat’s screws, beating on the thin hull of the submarine like drumbeats or someone forcing entry. Eyes sought the hull above them, and the silence intensified as the screws faded.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘HE fading, sir, and now bearing Green One-One-O.’ Something scraped on the hull, as if sliding past it. ‘Christ—’ someone breathed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Not yet, I hope,’ the captain murmured. ‘Hold tight, Commander,’ he added, as if aware of McBride for the first time. McBride clutched himself to the periscope housing, feeling slightly ridiculous, very weak, and dizzy with tension. He was shivering with cold. Then the muffled explosion beneath them and behind, the lurch through the length of the submarine, the flicker-douse-flicker back of the lights, water running from a slight leak, and the sense of people picking themselves out of a ruin and shaking themselves like wet hounds. Everyone grinning as the second depth charge roared like a breath some distance away.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Take her down, number one, to the bottom.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The first officer looked away from the diving panel. ‘It’s risky, sir.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The young-faced lieutenant commander replied: ‘We’ll sit this one out. Jerry will be buzzing around up there like a blue­arsed fly. He’s only got small depth charges, but even they could make a hole in our nice submarine—’ He grinned. ‘If we sit still, he’ll get cheesed off.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sir.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride felt the submarine settle gently on the bottom a moment later. A slight list to port. Silence. The pinging from the asdic seemed a long way away. The water had dribbled almost to a stop from the strain-leak.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Silent routine.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The captain looked into McBride’s face, as if assessing some prize he had won. When he nodded, McBride felt he had passed some test successfully. And was able to smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Thanks.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Your pal’s in my cabin, wants to talk to you—if you’re ready. Better change first, mm?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride nodded. The asdic increased its tempo once more, but McBride felt calmed by the confidence, the almost alien superiority these submariners exuded like a gas. He was out, and on his way home.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The next brace of depth charges shook the submarine, and the lights merely flickered. Someone cheered quietly.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Silly cunt!’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Bloody awful shot.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He followed the lieutenant commander out of the control room.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("October 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why won’t you tell me now, Goessler? Why do I have to play this elaborate bloody game which amuses you so much?’ Goessler’s companion was young, dark and broad­faced. The expression of the face was angry, creased into lines such as a bad-tempered child might display when denied some treat. It was a face that could have been pleasant, open, vivid with pleasure. But perhaps something of its secret life had grown on it like a patina, rusting the intensity of its emotions, restricting its expressiveness. Moynihan, sitting in Klaus Goessler’s office in Abteilung HQ in East Berlin—a grey Trade Ministry building on the Wilhelm-Pieckstrasse—was being made to feel younger than his twenty-eight years, and distinctly inferior in mind and position to the academic who was Deputy Director of the Abteilung’s Foreign Directorate.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Operations Commandant for the Belfast Battalion of the Provisional IRA writhed in silence under the unctuous yet steel voice of the balding German. Now, in answer to his blurted, sulky question, Goessler smoothed the wings of hair flat against his head, and smiled, leaning back in his leather chair. He looked over Moynihan’s head at an oil painting of the pre-war Unter Den Linden that hung on his office wall. Only after almost a half-minute did he speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘My dear Sean—’ Moynihan’s face winced at the pretended equality, its superiority sticking through like a broken bone. ‘I have explained to you. We must not be seen to be involved in this—the scandal must emerge ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("naturally.’ ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("His hands imitated a growth, an explosion, on the top of his desk. ‘Naturally, also, you have the impatience of all youth—’ A slight shake of the head. ‘As impatient as Professor McBride in his more academic way. If I told you ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("what, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you would want to take the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("how ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("into your own hands. Like a mad dog—which is what I sometimes think you are.’ A glint of contempt in Goessler’s eyes. ‘You would go for the throat. You would lose, like a poor actor, your sense of ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("timing ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("completely.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘God, do you think you’re running our show, or something, Goessler?’ Moynihan was holding one hand with the other on his lap, afraid to make them into protesting fists. But he could not control his tongue. ‘You’ve got the bloody bomb we need, you bastard! Give us the bloody thing and we’ll blow Guthrie and his fucking conference sky-high!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Goessler banged his hand flat on his desk, once. Leaned forward, and said, levelly, each word weighted: ‘That is exactly why you will not be told but will do as you are told. You are bomb-happy—real or metaphorical. You could not be trusted to exploit the situation to its maximum advantage. And, since you require an answer, I will reply ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("yes")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("—we do run your show. We sell you the guns, we provide the explosives, the funds, the false papers, the escape routes—the knowledge that any enterprise needs that its investors are powerful, and loyal.’ Goessler smiled. ‘Thus, you are here simply to ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("see ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride—when he moves on to England, you will go with him. When he reaches Ireland, as he no doubt will, you will take him over. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("He ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("will provide you with your explosion, without your help. Just let him do so—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Time is short,’ Moynihan snapped.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘This will not take long, Sean. ln a couple of days, at most, McBride will find what he needs here, and be on his way. A man has written to him from England—we will point him in that direction.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s all too coincidental!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("‘No, it is not!’ ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Goessler saw Moynihan blench, as if he sensed himself on enemy territory and without allies. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("‘Wait! ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It will work for you, and for us—and we will not be blamed for the collapse of the conference. Clocks will go back five years in Northern Ireland, and this time you will win.’ Goessler assessed that his instructions would be obeyed, then added, ‘Now, get out.’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5e22a7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmeraldDecision5.vue
// module id = 84
// module chunks = 0